import React, { useState, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import Requirements from './components/Requirements';
import Levels from './components/Levels';
import ShareGift from './components/ShareGift';
import ShareSection from './components/ShareSection';
import Contact from './components/Contact';
import Footer from './components/Footer'; // Pastikan ini ada
import './App.css';

function App() {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    // Check for saved theme preference
    const savedTheme = localStorage.getItem('theme');
    const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
    
    if (savedTheme) {
      setTheme(savedTheme);
    } else if (prefersDarkScheme.matches) {
      setTheme('dark');
    } else {
      setTheme('light');
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  const helmetData = {
    title: "Open Recruitment HOST MOMOLIVE - IDHO MANAGEMENT",
    description: "Pendaftaran host Momolive, Bigo Live, Nonolive, Migolive - Bergabung menjadi host dengan penghasilan menarik dan bonus 70% share gift!",
    keywords: "recruitment, host, momolive, bigolive, nonolive, migolive, livestreaming, agensi, indonesia",
    url: "https://www.idho-agency.web.id",
    image: ""
  };

  return (
    <HelmetProvider>
      <div className="App" data-theme={theme}>
        <Helmet>
          <title>{helmetData.title}</title>
          <meta name="description" content={helmetData.description} />
          <meta name="keywords" content={helmetData.keywords} />
          <meta property="og:title" content={helmetData.title} />
          <meta property="og:description" content={helmetData.description} />
          <meta property="og:image" content={helmetData.image} />
          <meta property="og:url" content={helmetData.url} />
          <meta name="twitter:title" content={helmetData.title} />
          <meta name="twitter:description" content={helmetData.description} />
          <meta name="twitter:image" content={helmetData.image} />
          <link rel="canonical" href={helmetData.url} />
        </Helmet>
        
        <Header theme={theme} toggleTheme={toggleTheme} scrollToSection={scrollToSection} />
        <Hero scrollToSection={scrollToSection} />
        <Requirements />
        <Levels />
        <ShareGift />
        <ShareSection />
        <Contact />
        <Footer />
        
        <a href="https://wa.me/6289505533503" className="floating-whatsapp" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-whatsapp"></i>
        </a>
      </div>
    </HelmetProvider>
  );
}

export default App;
